export default __webpack_public_path__ + "static/media/cheer.35a9b514.mp3";